import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text, View} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {StyledPressable} from 'components/Styled';
import {useTheme} from 'styled-components/native';

export interface OfferFilterProps {
  title?: string;
  icon?: string;
  count?: number;
  more?: number;
  onToggle?: () => void;
  isOpen?: boolean;
  altText?: string;
}

// const MOBILE_BREAKPOINT = BreakpointsEnum.SM;

const OfferFilter: React.FC<OfferFilterProps> = props => {
  const {isOpen, onToggle, title, icon, count, altText, more} = props;
  const theme = useTheme();
  const {paleSky} = theme.colors;
  const isDesktop = useIsDesktop();
  let actionIcon;

  if (isDesktop) {
    actionIcon = isOpen ? 'minus' : 'plus';
  } else {
    actionIcon = isOpen ? 'chevron-down' : 'chevron-right';
  }

  const handleToggle = () => {
    onToggle && onToggle();
  };

  return (
    <StyledPressable
      accessibilityRole="button"
      accessibilityHint={`This will display additional ${title} filters`}
      accessibilityLabel={`${isOpen ? 'Close' : 'Open'} ${title} Filters`}
      testID={`${title?.toLowerCase().split(' ').join('-')}-filter`}
      onPress={handleToggle}
      height="72px"
      marginX={4}>
      <View flexDirection="row" marginTop="28px">
        {icon && (
          <Icon
            name={icon}
            color={theme.colors.caesarRewards}
            size={theme.fontSizes[5]}
            solid
          />
        )}
        <View marginLeft={2} marginRight="auto" paddingRight={8} flex={1}>
          <View flexDirection="row" alignItems="baseline">
            <Text
              fontFamily="heading"
              fontSize={3}
              color={paleSky}
              fontWeight={700}
              letterSpacing="1px">
              {(title || '').toUpperCase()}
            </Text>
            {count !== undefined && (
              <Text
                fontSize="10px"
                color={paleSky}
                fontWeight={700}
                marginLeft={1}>
                {`(${count})`}
              </Text>
            )}
          </View>
          {!!altText && (
            <View flexDirection="row">
              <View flex={1}>
                <Text fontSize={2} color={paleSky} numberOfLines={1}>
                  {altText}
                </Text>
              </View>
              {more && (
                <Text
                  fontSize={2}
                  color={paleSky}
                  fontWeight={700}
                  marginLeft={1}>
                  {`+ ${more} more`}
                </Text>
              )}
            </View>
          )}
        </View>
        <Icon
          name={actionIcon}
          color={paleSky}
          size={theme.fontSizes[4]}
          solid
          light={isDesktop}
        />
      </View>
    </StyledPressable>
  );
};

export default OfferFilter;
